import { Trans, useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { CryptoPayout } from 'types/cryptoPayout';
import { CurrencyCode } from 'types/currency';

import { formatCryptoAmountWithSymbolAtEnd } from 'utils/cryptoFormatter';
import { formatFiatCurrencyI18n } from 'utils/i18n';
import { capitalizeFirstLetter } from 'utils/string';

import LABELS from './keys';
import { Item, ItemName, ItemValue, SecondaryItemValue, SectionWrapper, Spacer } from './styles';

interface CryptoPayoutExchangeSectionProps {
  payout: CryptoPayout;
}

export const CryptoPayoutExchangeSection = ({ payout }: CryptoPayoutExchangeSectionProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Panel label={t(LABELS.TITLE)}>
      <SectionWrapper>
        <Item>
          <ItemName>{t(LABELS.LIQUIDITY_PROVIDER)}</ItemName>
          <ItemValue>{capitalizeFirstLetter(payout.liquidityProvider ?? '-')}</ItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.TX_ID)}</ItemName>
          <SecondaryItemValue>{payout.liquidityProviderId}</SecondaryItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.CRYPTO_PRICE)}</ItemName>
          <ItemValue>
            <Trans
              i18nKey={LABELS.CRYPTO_PRICE_VALUE[0]}
              defaults={LABELS.CRYPTO_PRICE_VALUE[1]}
              values={{
                cryptoPrice: formatCryptoAmountWithSymbolAtEnd('1', payout.cryptoCurrencyCode ?? '-'),
                fiatValue: formatFiatCurrencyI18n(i18n.language)(Number(payout.cryptoPrice), payout.fiatCurrencyCode ?? CurrencyCode.USD),
              }}
              components={{ spacer: <Spacer /> }}
            />
          </ItemValue>
        </Item>
      </SectionWrapper>
    </Panel>
  );
};
